// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
import type {
  TIsSpecialistsCatalogAvailableRequest,
  TIsSpecialistsCatalogAvailableModel,
  IMappers,
  TIsSpecialistsCatalogAvailableResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IIsSpecialistsCatalogAvailableResponse } from '../../entities/specialist_catalog/IsSpecialistsCatalogAvailableResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createIsSpecialistsCatalogAvailableModel(
  parameters: TIsSpecialistsCatalogAvailableRequest,
): TIsSpecialistsCatalogAvailableModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'demand',
    pathApi: '/v1/is-specialists-catalog-available/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IIsSpecialistsCatalogAvailableOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TIsSpecialistsCatalogAvailableRequest;
}

export async function fetchIsSpecialistsCatalogAvailable<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IIsSpecialistsCatalogAvailableOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TIsSpecialistsCatalogAvailableResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createIsSpecialistsCatalogAvailableModel(parameters),
    config,
  )) as FetchResponse<TIsSpecialistsCatalogAvailableResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IIsSpecialistsCatalogAvailableResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TIsSpecialistsCatalogAvailableResponse>;
}
